import { Drawer, DrawerContent } from '@chakra-ui/react';
import { IconType } from 'react-icons';
import SidebarContent from './components/sidebar-content.component';

interface IMobileSidebarProps {
	isOpen: boolean;
	onClose: () => void;
	links: Array<{
		text: string;
		icon: IconType;
		to: string;
	}>;
}
export default function MobileSidebar(props: IMobileSidebarProps) {
	return (
		<Drawer
			autoFocus={false}
			isOpen={props.isOpen}
			placement="left"
			onClose={props.onClose}
			returnFocusOnClose={false}
			size="xs"
			onOverlayClick={props.onClose}
		>
			<DrawerContent display={{ base: 'block', lg: 'none' }}>
				<SidebarContent links={props.links} onClose={props.onClose} />
			</DrawerContent>
		</Drawer>
	);
}
